import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getServiceRequests,
  createServiceRequest,
  type CreateServiceRequestPayload,
} from '../apis/serviceRequests';
import type { ServiceRequestsResponse } from '../apis/serviceRequests';

export const serviceRequestKeys = {
  all: ['service-requests'] as const,
  lists: () => [...serviceRequestKeys.all, 'list'] as const,
  list: (filters?: Record<string, unknown>) =>
    [...serviceRequestKeys.lists(), filters ?? {}] as const,
};

/**
 * Hook to fetch service requests (partner auth required)
 */
export function useServiceRequests(params?: {
  status?: string;
  page?: number;
  limit?: number;
}) {
  return useQuery<ServiceRequestsResponse, Error>({
    queryKey: serviceRequestKeys.list(params),
    queryFn: () => getServiceRequests(params),
    staleTime: 30 * 1000,
  });
}

/**
 * Hook to create a service request (partner auth required)
 */
export function useCreateServiceRequest() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreateServiceRequestPayload) =>
      createServiceRequest(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: serviceRequestKeys.all });
    },
  });
}
